import { Injectable } from '@angular/core';
import { PaginatedState, PaginatedStateModel } from '@shared/ui';

export interface CaseTypeData {
  id: string;
  name: string;
  description: string;
  usedByWorkspaces?: number; // undefined = not loaded yet
  usedByCases?: number; // undefined = not loaded yet
}

export interface CaseTypeStateModel extends PaginatedStateModel<CaseTypeData> {
  selectedCaseTypeId: string | undefined;
}

@Injectable()
export class CaseTypeState extends PaginatedState<CaseTypeData, CaseTypeStateModel> {
  constructor() {
    super(undefined, { selectedCaseTypeId: undefined });
  }

  // Selection tracking
  public readonly selectedCaseTypeId$ = this.select((state) => state.selectedCaseTypeId);
  public readonly selectedCaseType$ = this.select(
    this.items$,
    this.selectedCaseTypeId$,
    (items, id) => items.find((item) => item.id === id) ?? undefined
  );
}
